import React, { lazy, Suspense } from 'react'
import { MdModeEdit as EditIcon } from 'react-icons/md'
import { observable } from 'mobx'
import { observer } from 'mobx-react'
import { i18nTranslate, isFeatureEnabled } from 'src/utils'
import { Button, Row, Col } from 'react-bootstrap'
import {
  addressContainer,
  accountsAddressContainer,
  storeContainer,
  customerContainer,
  nlxxConfigContainer,
} from 'src/models'
import { AddressValidation, toastState } from 'src/views/components'
import { AddressDetail } from './AddressDetail'
import { application, isB2BUser, getLocalStorage } from 'src/utils'
import { handleAddressValidation } from 'src/deps'
import { IS_BROWSER } from 'config/appConfig'
import './styles.scss'
import {
  removeShippingAddressFormValidationMeta,
  shouldMakeLegacyAddressValidationApiCall,
  wasValidatedByShippingAddressForm,
} from 'src/views/components/CommonFormForCS/shippingAddressFormValidation'

@observer
class AddressList extends React.Component {
  @observable isEdit = false
  @observable show = false
  @observable addressInvalidFlag = false
  @observable recommendations = []
  @observable isDefault = false

  currentMarket = storeContainer?.defaultShippingRegion
    ? 'Address' + storeContainer?.defaultShippingRegion
    : 'AddressUS'
  AddressForm = lazy(
    () =>
      import(
        'src/views/addresses/' + this.currentMarket + '/' + this.currentMarket
      )
  )

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    // Load NLXX configuration on mount if not already loaded for current store
    if (
      !nlxxConfigContainer.nlxxConfigStoreId ||
      nlxxConfigContainer.nlxxConfigStoreId !== storeContainer.activeStoreId
    ) {
      nlxxConfigContainer.loadNLXXConfig()
    }
  }

  toggleEditAddress = () => {
    this.isEdit = !this.isEdit
  }

  handleDefaultAddress = () => {
    if (/*isB2BAdmin() ||*/ isB2BUser()) {
      accountsAddressContainer.updateDefaultAddress(this.props?.addressInfo)
    } else {
      addressContainer.updateDefault(this.props?.addressInfo)
    }
  }

  handleUpdateAddress = async (formData = {}, addressInfo = {}) => {
    //COMMENTED below lines of code as we already receiving parsed phone number from formData
    //Start of joining phonenumber and code
    // const { phone = '', phoneCountryCode = '', ...remainingProps } = formData
    // const phoneNumber = await parsePhoneNumberField(phone, phoneCountryCode)
    //   ?.number
    // formData = { phone: phoneNumber, ...remainingProps }
    // End of joining phonenumber and code

    const defaultFlag = addressInfo?.isDefault || false
    this.isDefault =
      defaultFlag === true ||
      (defaultFlag === false && formData?.setDefaultAddress === true) ||
      false

    formData = { ...formData, isDefault: this.isDefault }
    let formDataTemp = {
      ...formData,
      shippingInstructions: formData?.shippingInstructions || '',
      setDefaultAddress: this.isDefault
        ? this.isDefault
        : formData?.setDefaultAddress || false,
    }
    const isToMakeAddressValidationApi =
      shouldMakeLegacyAddressValidationApiCall(
        formData,
        storeContainer?.defaultShippingRegion
      )

    if (!isToMakeAddressValidationApi) {
      this.handleClickOnPro(formData, false)
      return
    }

    formData = removeShippingAddressFormValidationMeta(formData)
    formDataTemp = removeShippingAddressFormValidationMeta(formDataTemp)

    const addressValditationFlag = await handleAddressValidation(
      formDataTemp,
      addressInfo
    )
    if (addressValditationFlag === true) {
      const res = await addressContainer.validateAddress(formData)

      if (res?.code === 'ADCOVAL0003') {
        this.recommendations = [{ ...formDataTemp }, []]
        this.formDataEnter = { ...formDataTemp }
        this.addressInvalidFlag = true
        this.show = true
      } else if (res?.code == 'ONESOURCE_ADPLGIN_VAL_ERROR') {
        this.setState({
          show: false,
        })
        toastState.setToastMessage(
          i18nTranslate('address.NotAdded', 'Address not added')
        )
        return
      } else if (res?.code === 'AOACHLD0001') {
        this.setState({
          show: false,
        })
        toastState.setToastMessage(
          i18nTranslate(
            'myaccount.userHoldStatus',
            'There is an issue with your account. Please contact you local account manager.'
          )
        )
        return
      } else {
        const recommendationAddress =
          res?.address?.validationDetails?.[0]?.recommendations || []
        let firstAddress = recommendationAddress?.[0] || {}
        if (
          Object.keys(firstAddress)?.length > 0 &&
          handleAddressValidation(formDataTemp, firstAddress)
        ) {
          // const validationcode = res.address.validationDetails[0].responseCode
          this.recommendations = [{ ...formDataTemp }, ...recommendationAddress]
          this.formDataEnter = { ...formDataTemp }
          this.addressInvalidFlag = false
          this.show = true
        } else {
          this.formDataEnter = { ...formDataTemp }
          this.handleClickOnPro(formDataTemp, true)
        }
      }
    } else {
      this.handleClickOnPro(formData, false)
    }
  }

  handleClickOnPro = async (formData = {}, isAddressUpdated = true) => {
    const isValidatedByShippingAddressForm =
      wasValidatedByShippingAddressForm(formData)
    formData = removeShippingAddressFormValidationMeta(formData)

    if (isAddressUpdated) {
      formData.isDefault = this.formDataEnter?.setDefaultAddress || false
    }
    if (/*isB2BAdmin() ||*/ isB2BUser()) {
      await accountsAddressContainer.updateAddress(
        formData,
        this.props?.addressInfo
      )
      this.handleClose()
      this.toggleEditAddress()
    } else {
      if (formData.selectedIndex <= 0 && !isValidatedByShippingAddressForm) {
        let response = await addressContainer.validateUpdatedAddress(
          formData,
          this.props?.addressInfo
        )
        this.handleClose()
        if (addressContainer.isSuccessResponse(response)) {
          this.toggleEditAddress()
        }
      } else {
        const isAddressBookPinValidation = isFeatureEnabled(
          'validatePincodeInAddressBookForSubsProduct'
        )
        await addressContainer.updateAddress(
          formData,
          this.props?.addressInfo,
          false,
          isAddressBookPinValidation
        )
        this.handleClose()
        this.toggleEditAddress()
      }
    }
  }

  handleClose = () => {
    this.show = false
  }

  getDataModal() {
    return {
      addressInfo: this.props?.addressInfo || {},
      index: this.props?.index,
      saveChangesText: i18nTranslate('address.save', 'Save Changes'),
      editIconLabel: i18nTranslate('address.editIcon', 'Open edit Information'),
      show: this.show || false,
      addressInvalidFlag: this.addressInvalidFlag || false,
      recommendations: this.recommendations || [],
      isEdit: this.isEdit || false,
    }
  }

  getStyleGuides() {
    let homeCountry = ''
    customerContainer?.profileResponse?.accounts?.properties?.forEach(
      element => {
        if (element.attributeId === 'countryCode') {
          homeCountry = element.value
        }
      }
    )
    if (homeCountry === 'CA') {
      homeCountry = 'Canada'
    }
    const isCrossMarketAllowedFlag =
      customerContainer?.isCrossMarketAllowed?.() || false
    const homeAccountType = getLocalStorage('accountType')
    const isBrandAffiliateAccount =
      homeAccountType === 'Brand Affiliate' ||
      homeAccountType === 'Brand Affiliate - Business Entity'
    const isRetailOrMemberHomeMarket =
      (homeAccountType === 'Retail Customer' ||
        homeAccountType === 'Preferred Customer/Member') &&
      homeCountry === storeContainer.storeIDValue
    const isToShowEditButton =
      isCrossMarketAllowedFlag ||
      isBrandAffiliateAccount ||
      isRetailOrMemberHomeMarket

    return {
      hideMessageClass: isToShowEditButton ? '' : 'd-none',
      size: application.isMobile ? 'md' : 'lg',
    }
  }

  renderAddressBookEditSubmitButton = () => {
    return (
      <Row noGutters className="justify-content-start">
        <div className="d-flex">
          <div>
            <Button
              variant="primary"
              className="add-button-addressBook mt-2 shipping-button-addressBook justify-content-center align-items-center"
              type="submit"
              data-testid="qa-submit-changes">
              {i18nTranslate('address.save', 'Save Changes')}
            </Button>
          </div>
          <div className="ml-3">
            <Button
              variant="outline-primary"
              className="cancel-button-addressBook mt-2 shipping-button-addressBook justify-content-center align-items-center"
              onClick={this.toggleEditAddress}
              data-testid="qa-address-cancel">
              {i18nTranslate('address.cancel', 'Cancel')}
            </Button>
          </div>
        </div>
      </Row>
    )
  }

  render() {
    const data = this.getDataModal()
    const styles = this.getStyleGuides()
    const addressContainerClassName = customerContainer?.isRegisterUser
      ? 'p-3 my-3 bg-white address-container shadow-sm'
      : 'address-container d-none'

    return (
      <Row
        noGutters
        className={addressContainerClassName}
        data-testid="qa-address-container">
        <Col className="d-flex flex-column">
          {data?.show && (
            <AddressValidation
              open={data?.show}
              addressInvalidFlag={data?.addressInvalidFlag}
              recommendations={data?.recommendations}
              handleClose={this.handleClose}
              handleClickOnPro={this.handleClickOnPro}
            />
          )}
          {!isB2BUser() && !data?.isEdit && (
            <Button
              tabIndex={0}
              className={`${styles?.hideMessageClass} position-absolute p-0 edit-address shadow-none`}
              variant="black"
              size={styles?.size}
              data-testid="qa-add-edit"
              onClick={this.toggleEditAddress}>
              <EditIcon aria-label={data?.editIconLabel} />
            </Button>
          )}
          {!data?.isEdit ? (
            <AddressDetail
              addressInfo={data?.addressInfo}
              index={data?.index}
            />
          ) : (
            <Row noGutters className="pt-4">
              <Col className="p-0">
                {IS_BROWSER && (
                  <Suspense fallback="">
                    <this.AddressForm
                      index={data?.index}
                      addressInfo={data?.addressInfo}
                      onSubmit={this.handleUpdateAddress}
                      onCancel={this.toggleEditAddress}
                      renderSubmitButton={
                        this.renderAddressBookEditSubmitButton
                      }
                      type="addressBook"
                    />
                  </Suspense>
                )}
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    )
  }
}

export { AddressList }
export default AddressList
